import FaqProviderInterface from '~/lib/faq/FaqProviderInterface'
import BaseFaqProvider from '~/lib/faq/BaseFaqProvider'

const brand = process.env.brand as any

export default class FaqProviderBuilder {
  static getProvider(): FaqProviderInterface {
    return new BaseFaqProvider(brand.name, brand.phone, brand.support, brand.salesEmail)
  }
}